
  import blogQuery from '@/apollo/queries/blog/blogMainPage'
  import pageMeta from '~/mixins/pageMeta.js';
  
  export default {
    mixins: [pageMeta],

    name: "Blog",

    layout: 'white',
    data() {
      return {
        pageData: {
          type: Object,
          default: () => {},
        },
        loading: 0,
        filters: {},
        showSearch: false,
        isBlogSideWidgetActive: false
      };
    },
    apollo: {
      $loadingKey: "loading",
      pageData: {
        prefetch: true,
        query: blogQuery,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
        },
        update(data) {
          return this.$normalizeStrapi(data.blogMainPage.data);
        },
      },
    },

    computed: {
        BlogFiltersTagCodes () {
            return this.$store.getters['blog/filtersTagCodes']
        },
        BlogFiltersAuthorCodes() {
            return this.$store.getters['blog/filtersAuthorCodes']
        },
    },    

    mounted() {
      const _vue = this // << here
      this.$nextTick(()=>{
        let scrollUpCounter = 0
        let scrollDownCounter = 0
        const scrollUpBuffer = 20
        const scrollDownBuffer = 5
        const scrollDownToHide = 20
        const clientWidth = document.body.clientWidth
        if (clientWidth < 1025) {
          this.$store.commit('blog/setDesktopMenuState', false)
        } else {
          this.$store.commit('blog/setDesktopMenuState', true)
        }

        /* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
        let prevScrollpos = window.pageYOffset;
        const el = document.getElementsByClassName("blog-sidebar-layout")
        window.onscroll = function() {
          const clientWidth = document.body.clientWidth
          const currentScrollPos = window.pageYOffset;
          // console.debug('currentScrollPos:',currentScrollPos)

          if (currentScrollPos > prevScrollpos) {
            scrollDownCounter++
            scrollUpCounter = 0
            
            if ( currentScrollPos < 200 ){
              _vue.showBlogSideWidget(false)
            }


            if ( scrollDownCounter - scrollDownBuffer > scrollDownToHide ){
              _vue.showFullBlogFilter(false)
              scrollUpCounter = 0
            }


          }
          
          if (prevScrollpos > currentScrollPos) {
            scrollUpCounter++
            scrollDownCounter = 0
            if(scrollUpCounter > 30) {
              _vue.showFullBlogFilter(true)
            }
            
            if ( checkVisible(el[0]) ){
              if(clientWidth > 400) {
                //
                // _vue.showFullBlogFilter(false)
              }
            }
            
            if ( currentScrollPos < 200 ){
              _vue.showBlogSideWidget(false)
            }
            
            if ( currentScrollPos < 5 ){
              if(clientWidth > 1024) {
                _vue.showFullBlogFilter(true)
              }
            }
    
          } else if ( currentScrollPos > 500 && currentScrollPos < 1500 ){
            // if(clientWidth > 1400) {
            //   _vue.showBlogSideWidget(true)
            // }
            
          } else { 
            _vue.showBlogSideWidget(false)
            // _vue.showFullBlogFilter(false)
          }
          prevScrollpos = currentScrollPos;
          
          // console.debug('scrollUpCounter, scrollDownCounter, currentScrollPos: ',scrollUpCounter, scrollDownCounter, currentScrollPos)
        }

      })

      function checkVisible(elm, threshold, mode) {
        threshold = threshold || 0;
        mode = mode || 'visible';

        if(elm) {
          const rect = elm.getBoundingClientRect();
          const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
          const above = rect.bottom - threshold < 0;
          const below = rect.top - viewHeight + threshold >= 0;

          return mode === 'above' ? above : (mode === 'below' ? below : !above && !below);
        }
        return false
      }
    },

    methods: {
      closeSearch() {
        this.showSearch = false
      },
      updateTagCodes(event){
        this.filters = event.filters;
        console.debug(event);
      },
      showBlogSideWidget(boolean) {
        this.isBlogSideWidgetActive = boolean
      },
      showFullBlogFilter(boolean) {
        this.$store.commit('blog/setDesktopMenuState', boolean)
      }
    },

  }
